import { Component, OnInit } from '@angular/core';
import { PopupsManagerService } from '../../services/popups-manager.service';
import { Router } from '@angular/router';
import { AuthService } from '../../services/auth.service';
import { finalize, takeUntil } from 'rxjs/operators';
import { BaseComponent } from '../../common/base/base.component';
import { HowToComponent } from '../how-to/how-to.component';
import { TilesService } from '../../services/tiles.service';
import { TileStats } from '../../common/types/tiles';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent extends BaseComponent implements OnInit {
  public cartItemsCount: number | undefined;
  public publicId: string | undefined;
  public isConnected: boolean | undefined;
  public loading: boolean | undefined;
  public tileStats: TileStats | undefined;

  constructor(
    private router: Router,
    private cartService: TilesService,
    private authService: AuthService,
    private commonService: CommonService,
    private popupsManagerService: PopupsManagerService
  ) {
    super();
  }

  ngOnInit(): void {
    this.authService.signInRequest$.subscribe(() => this.signInWithMetamask());
    this.cartService.cartItems$.subscribe(
      (items) => (this.cartItemsCount = items.length)
    );
    this.authService.publicIdChange$.subscribe((res) => {
      this.publicId = res;
      if (res) {
        this.isConnected = true;
      }
    });
    this.commonService
      .fetchTilesStats()
      .pipe(takeUntil(this.destroy$))
      .subscribe((tileStats: TileStats) => (this.tileStats = tileStats));
  }

  public openHowToPopup(): void {
    this.popupsManagerService.show(HowToComponent, { className: 'overlay' });
  }

  public signInWithMetamask(): void {
    if (this.loading) {
      return;
    }
    this.loading = true;
    this.authService
      .signInWithMetamask()
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => (this.loading = false))
      )
      .subscribe(() => {
        this.isConnected = true;
      });
  }
}
